import React, { useState } from "react";
import { Link } from "react-router-dom";

type ThisProps = {
  aktuelleseite: string,
}

const MenuComponent: React.FC<ThisProps> = (props) => {
 
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-green-700 text-white w-full shadow-sm">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">

          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              className="h-16 w-16 object-contain"
              src="/img/concordia_neermoor_logo_3d_klein_transparent.png"
              alt="Logo"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-6">
            <Link className="hover:text-gray-200" to="/">Startseite</Link>
            <Link className="hover:text-gray-200" to="/anmeldung">Anmeldung</Link>
            <Link className="hover:text-gray-200" to="/teilnehmerliste">Teilnehmer</Link>
            <Link className="hover:text-gray-200" to="/rangliste">Rangliste</Link>
          </div>

          {/* Mobile Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden focus:outline-none"
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden px-4 pb-4 space-y-2">
          <Link className="block hover:text-gray-200" to="/">Startseite</Link>
          <Link className="block hover:text-gray-200" to="/anmeldung">Anmeldung</Link>
          <Link className="block hover:text-gray-200" to="/teilnehmerliste">Teilnehmer</Link>
          <Link className="block hover:text-gray-200" to="/rangliste">Rangliste</Link>
        </div>
      )}
    </nav>
  );
}

export default MenuComponent;
